export const MEDIA_TYPE = {
  mp4: 'video/mp4',
  mov: 'video/mov',
};

export const ABOUT_TITLE = 'About The Program';
